// extracted by mini-css-extract-plugin
export default {"Modal":"style_Modal__bn3fZ","Controls":"style_Controls__3flXu"};